<template>
  <div data-slot="grid-card" class="flex flex-col gap-3 rounded-lg border bg-card p-5">
    <slot />
    <div v-if="$slots.footer" class="mt-auto flex items-center gap-2 pt-1"><slot name="footer" /></div>
  </div>
</template>

<script setup lang="ts">
// One card in a CardGrid: its name and state, what it holds, then its action at
// the foot, so the actions line up across a row of cards of different lengths.
</script>
